import React from 'react';
import Select from '../Select/Select';

export const MARITAL_STATUSES = [
  { value: 1, label: 'Ð¥Ð¾Ð»Ð¾ÑÑ/Ð½Ðµ Ð·Ð°Ð¼ÑÐ¶ÐµÐ¼' },
  { value: 2, label: 'ÐÐµÐ½Ð°Ñ/ÐÐ°Ð¼ÑÐ¶ÐµÐ¼' },
  { value: 3, label: 'Ð Ð°Ð·Ð²ÐµÐ´ÐµÐ½/ÑÐ°Ð·Ð²ÐµÐ´ÐµÐ½Ð°' },
  { value: 4, label: 'ÐÐ´Ð¾Ð²ÐµÑ/Ð²Ð´Ð¾Ð²Ð°' },
  { value: 5, label: 'ÐÑÐ°Ð¶Ð´Ð°Ð½ÑÐºÐ¸Ð¹ Ð±ÑÐ°Ðº' },
];

const SelectFamilyStatus = ({ ...props }) => {
  return <Select options={MARITAL_STATUSES} label={'Ð¡ÐµÐ¼ÐµÐ¹Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectFamilyStatus;
